"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class MultiLayerDropdown {
    element;
    main_wrapper = document.createElement('div');
    input = document.createElement('input');
    dropdown = document.createElement('div');
    dropdown_wrapper = document.createElement('div');
    chip_container_wrapper = document.createElement('div');
    chip_container = document.createElement('div');
    main_invisible_input = document.createElement('input');
    form_input_container = document.createElement('div');
    icon_templates = {
        checkboxIcon: `<svg xmlns="http://www.w3.org/2000/svg" class="checkbox-icon" width="14.071" height="11.062"
                                viewBox="0 0 14.071 11.062"><path id="Path_469" data-name="Path 469" d="M13.5,12.054l2.594,2.594L24.742,6"
                                transform="translate(-12.086 -4.586)" fill="none" stroke="#46d2c4"
                                stroke-linecap="round" stroke-linejoin="round" stroke-width="2" />
                        </svg>`,
        indeterminateCheckboxIcon: `<svg xmlns="http://www.w3.org/2000/svg" class="int-checkbox-icon" height="24px" viewBox="0 -960 960 960" width="24px" fill="#46d2c4"><path d="M280-440h400v-80H280v80Zm-80 320q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h560q33 0 56.5 23.5T840-760v560q0 33-23.5 56.5T760-120H200Z"/></svg>`,
    };
    options = {
        search: true,
        searchPlaceholder: 'Search...',
        entry: 'item',
        levels: ['Level 1', 'Level 2', 'Level 3', 'Level 4', 'Level 5', 'Level 6', 'Level 7', 'Level 8', 'Level 9', 'Level 10'],
        keys: ['key 1', 'key 2', 'key 3', 'key 4', 'key 5', 'key 6', 'key 7', 'key 8', 'key 9', 'key 10'],
        parentSelect: false,
        parentSelectAll: false,
        disableChildrenOnParentSelect: false,
        multiSelect: true,
        createIndividualInputFields: true,
        createDuplicateKeyInputFields: false,
    };
    dropdown_items = { key_items: [], all_items: [] };
    selected_items = [];
    #level = 0;
    #bias = 5;
    #toggle_dropdown;
    initializeData(data) {
        this.resetDropdown();
        this.dropdown.appendChild(this.#attach_select_all_to_label(this.#level));
        data.forEach((item) => {
            this.addItem(item);
        });
    }
    resetDropdown() {
        this.dropdown.innerHTML = '';
        this.chip_container.innerHTML = '';
        this.input.value = '';
        this.input.placeholder = this.options.searchPlaceholder;
        this.dropdown_items = {
            key_items: [],
            all_items: []
        };
        this.selected_items = [];
        this.dropdown_wrapper.remove();
    }
    addGroupLabel(name, prepend) {
        const group_label_wrapper = this.#create_group_label(name);
        if (prepend) {
            this.dropdown.prepend(group_label_wrapper);
        }
        else {
            this.dropdown.appendChild(group_label_wrapper);
        }
    }
    appendHtml(html) {
        const element = document.createElement('div');
        element.outerHTML = html;
        this.dropdown.appendChild(element);
    }
    addItem(item, prepend) {
        const dropdown_item_data = this.#create_dropdown_item(item);
        if (prepend) {
            this.dropdown.prepend(dropdown_item_data.wrapper);
        }
        else {
            this.dropdown.appendChild(dropdown_item_data.wrapper);
        }
    }
    getNames() {
        let obj = {};
        this.selected_items.forEach((entry) => {
            if (!obj[this.options.keys[entry.item.key_no]])
                obj[this.options.keys[entry.item.key_no]] = [];
            obj[this.options.keys[entry.item.key_no]].push(entry.item.name);
        });
        return obj;
    }
    getValuesWithParent() {
        let obj = [];
        this.selected_items.forEach((entry) => {
            const key = this.options.keys[entry.item.key_no];
            if (!obj[key])
                obj[key] = [];
        });
        return obj;
    }
    getValues() {
        let obj = {};
        this.selected_items.forEach((entry) => {
            if (!obj[this.options.keys[entry.item.key_no]])
                obj[this.options.keys[entry.item.key_no]] = [];
            obj[this.options.keys[entry.item.key_no]].push(entry.item.value);
        });
        return obj;
    }
    getKeyValuesOnly(key) {
        let arr = [];
        this.selected_items.forEach((entry) => {
            if (entry.item.key_no !== this.options.keys.indexOf(key))
                return;
            let obj = {};
            obj[key] = {
                value: entry.item.value,
                name: entry.item.name
            };
            if (entry.item.children) {
                const childKey = this.options.keys[entry.item.key_no + 1];
                obj[childKey] = entry.item.children.map(child => {
                    return {
                        value: child.value,
                        name: child.name,
                        selected: child.isSelected
                    };
                });
            }
            arr.push(obj);
        });
        return arr;
    }
    selectItems(terms) {
        for (const key in terms) {
            let key_number = this.options.keys.indexOf(key);
            if (key_number !== -1) {
                terms[key].forEach((term) => {
                    this.dropdown_items.key_items[key_number].forEach((item) => {
                        if (item.value === term) {
                            item.select();
                        }
                    });
                });
            }
        }
    }
    clear() {
        this.dropdown_items.all_items.forEach((item) => {
            item.deselect();
        });
    }
    setLevels(levels) {
        this.options.levels = levels;
    }
    setPlaceholder(placeholder) {
        this.options.searchPlaceholder = placeholder;
        this.input.setAttribute('placeholder', placeholder);
    }
    constructor(element, options) {
        let e;
        if (typeof element === 'string') {
            e = document.querySelector(element);
            if (!e) {
                throw new Error('Element not found');
            }
        }
        else {
            e = element;
        }
        this.element = e;
        this.options = { ...this.options, ...options };
        this.#attribute_options();
        Object.defineProperty(this.element, 'value', {
            get: () => {
                return this.getValues();
            },
        });
        this.element.__multi_layer_instance = this;
        this.#init_structure();
    }
    #attribute_options() {
        if (this.element.getAttribute('data-parent-select') !== null) {
            this.options.parentSelect = this.element.getAttribute('data-parent-select') === 'true' ? true : false;
        }
        if (this.element.getAttribute('data-parent-select-all') !== null) {
            this.options.parentSelectAll = this.element.getAttribute('data-parent-select-all') === 'true' ? true : false;
        }
        if (this.element.getAttribute('data-multi-select') !== null) {
            this.options.multiSelect = this.element.getAttribute('data-multi-select') === 'true' ? true : false;
        }
        if (this.element.getAttribute('data-disable-children-on-parent-select') !== null) {
            this.options.disableChildrenOnParentSelect = this.element.getAttribute('data-disable-children-on-parent-select') === 'true' ? true : false;
        }
        if (this.element.getAttribute('data-name')) {
            this.options.createIndividualInputFields = false;
            this.options.createDuplicateKeyInputFields = false;
        }
        else if (this.element.getAttribute('data-duplicate-input-key-fields')) {
            this.options.createIndividualInputFields = true;
            this.options.createDuplicateKeyInputFields = true;
        }
    }
    #init_structure() {
        this.main_wrapper.classList.add('multi-layer-dropdown-main-wrapper');
        this.form_input_container.classList.add('form-input-container');
        const input_wrapper = document.createElement('div');
        input_wrapper.classList.add('multi-layer-dropdown-input');
        this.input.placeholder = this.options.searchPlaceholder;
        this.input.addEventListener('input', (e) => {
            const value = e.target.value;
            this.#search(value);
        });
        const input_dropdown_icon = document.createElement('span');
        input_dropdown_icon.classList.add('material-symbols-rounded');
        input_dropdown_icon.innerHTML = 'expand_more';
        input_wrapper.appendChild(this.input);
        input_wrapper.appendChild(input_dropdown_icon);
        input_dropdown_icon.addEventListener('click', (e) => {
            toggle_dropdown(!input_dropdown_icon.classList.contains('expand'));
        });
        input_wrapper.addEventListener('click', (e) => {
            if (e.target === input_dropdown_icon)
                return;
            toggle_dropdown(true);
        });
        document.body.addEventListener('click', (e) => {
            if (e.target === this.input || e.target === input_dropdown_icon
                || e.target === input_wrapper)
                return;
            toggle_dropdown(false);
        });
        const toggle_dropdown = (open) => {
            if (open) {
                if (this.dropdown_wrapper.parentNode)
                    return;
                document.body.appendChild(this.dropdown_wrapper);
                this.#set_dropdown_css(this.dropdown_wrapper, this.element);
                document.querySelector('#main_container').addEventListener('scroll', () => {
                    this.#set_dropdown_css(this.dropdown_wrapper, this.element);
                });
                window.addEventListener('resize', () => {
                    this.#set_dropdown_css(this.dropdown_wrapper, this.element);
                });
                input_dropdown_icon.classList.add('expand');
            }
            else {
                input_dropdown_icon.classList.remove('expand');
                if (!this.options.multiSelect) {
                    this.input.value = '';
                    this.#search('');
                }
                gsap.to(this.dropdown_wrapper, {
                    opacity: 0,
                    duration: 0.15,
                    onComplete: () => {
                        this.dropdown_wrapper.remove();
                    },
                    clearProps: 'opacity'
                });
            }
        };
        this.#toggle_dropdown = toggle_dropdown;
        this.dropdown.classList.add('multi-layer-dropdown');
        this.dropdown_wrapper.classList.add('multi-layer-dropdown-wrapper');
        this.dropdown_wrapper.appendChild(this.dropdown);
        this.dropdown_wrapper.addEventListener('click', (e) => {
            e.stopPropagation();
        });
        this.chip_container.classList.add('multi-layer-dropdown-chip-container');
        this.chip_container_wrapper.classList.add('multi-layer-dropdown-chip-container-wrapper', 'hidden');
        this.chip_container_wrapper.appendChild(this.chip_container);
        const container_clear_icon = document.createElement('span');
        container_clear_icon.classList.add('material-symbols-rounded', 'clear');
        container_clear_icon.innerHTML = 'clear';
        container_clear_icon.addEventListener('click', () => {
            this.clear();
        });
        this.chip_container_wrapper.appendChild(container_clear_icon);
        this.main_wrapper.appendChild(input_wrapper);
        this.main_wrapper.appendChild(this.chip_container_wrapper);
        this.main_wrapper.appendChild(this.form_input_container);
        if (!this.options.createIndividualInputFields) {
            this.main_invisible_input.setAttribute('name', this.element.getAttribute('data-name') ?? '');
            this.form_input_container.appendChild(this.main_invisible_input);
        }
        this.element.appendChild(this.main_wrapper);
    }
    #create_dropdown_item(item, parent = undefined) {
        const dropdown_item_wrapper = document.createElement('div');
        dropdown_item_wrapper.classList.add('dropdown-item-wrapper');
        const dropdown_item_element = document.createElement('div');
        dropdown_item_element.classList.add('dropdown-item');
        dropdown_item_element.setAttribute('data-value', item.value);
        dropdown_item_element.setAttribute('data-name', item.name);
        const labelContainer = document.createElement('div');
        labelContainer.classList.add('label-container');
        const label = document.createElement('p');
        label.innerText = item.name;
        const DROPDOWN_ITEM = {
            name: item.name,
            element: dropdown_item_element,
            wrapper: dropdown_item_wrapper,
            value: item.value ?? item.name,
            parent: parent,
            key_no: this.#level,
            key: this.options.keys[this.#level],
            isSelected: false,
            isActive: item.active,
            checkbox_element: null,
            selected_children_count: 0,
            shouldSelectAll: () => {
                if (!DROPDOWN_ITEM.children)
                    return false;
                return DROPDOWN_ITEM.selected_children_count >= DROPDOWN_ITEM.children.length;
            },
            setActive(active) {
                this.isActive = active;
                this.element.classList.toggle('in-active', !active);
            },
            _select: () => {
                if (DROPDOWN_ITEM.isSelected || !DROPDOWN_ITEM.isActive)
                    return;
                if (this.options.multiSelect) {
                    const chip = this.#create_chip(DROPDOWN_ITEM);
                    this.chip_container.appendChild(chip);
                    this.selected_items.push({ item: DROPDOWN_ITEM, chip });
                    DROPDOWN_ITEM.checkbox_element?.setAttribute('checked', 'true');
                    DROPDOWN_ITEM.parent ? DROPDOWN_ITEM.parent.selected_children_count++ : null;
                }
                else {
                    DROPDOWN_ITEM.element.classList.add('single-selected');
                    this.selected_items = [{ item: DROPDOWN_ITEM, chip: undefined }];
                }
                DROPDOWN_ITEM.isSelected = true;
            },
            _deselect: () => {
                if (!DROPDOWN_ITEM.isSelected || !DROPDOWN_ITEM.isActive)
                    return;
                if (this.options.multiSelect) {
                    const index = this.selected_items.findIndex((selected_item) => selected_item.item === DROPDOWN_ITEM);
                    if (index !== -1) {
                        const removed_item = this.selected_items.splice(index, 1);
                        removed_item[0].chip?.remove();
                    }
                    DROPDOWN_ITEM.checkbox_element?.setAttribute('checked', 'false');
                    DROPDOWN_ITEM.parent ? DROPDOWN_ITEM.parent.selected_children_count-- : null;
                }
                else {
                    DROPDOWN_ITEM.element.classList.remove('single-selected');
                    this.selected_items = [];
                }
                DROPDOWN_ITEM.isSelected = false;
            },
        };
        if (this.options.multiSelect) {
            const checkbox = document.createElement('button');
            labelContainer.appendChild(checkbox);
            DROPDOWN_ITEM.checkbox_element = checkbox;
            DROPDOWN_ITEM.select = () => {
                if (DROPDOWN_ITEM.isSelected || !DROPDOWN_ITEM.isActive)
                    return;
                checkbox.setAttribute('checked', 'false');
                checkbox.dispatchEvent(new Event('click'));
            };
            DROPDOWN_ITEM.deselect = () => {
                if (!DROPDOWN_ITEM.isSelected || !DROPDOWN_ITEM.isActive)
                    return;
                checkbox.setAttribute('checked', 'true');
                checkbox.dispatchEvent(new Event('click'));
            };
            DROPDOWN_ITEM.toggleSelect = () => {
                checkbox.dispatchEvent(new Event('click'));
            };
            checkbox.addEventListener('click', (e) => {
                e.stopPropagation();
                if (DROPDOWN_ITEM.isActive) {
                    if (this.options.parentSelectAll && DROPDOWN_ITEM.checkbox_element?.getAttribute('int') === 'true') {
                        checkbox.setAttribute('checked', 'true');
                    }
                    else
                        checkbox.setAttribute('checked', checkbox.getAttribute('checked') === 'true' ? 'false' : 'true');
                    this.#toggle_selection_of_item(DROPDOWN_ITEM);
                    this.#fire_events(DROPDOWN_ITEM, 'itemClick', checkbox.getAttribute('checked') === 'true' ? 'itemSelect' : 'itemDeselect');
                }
            });
        }
        else {
            DROPDOWN_ITEM.select = () => {
                if (DROPDOWN_ITEM.isSelected || !DROPDOWN_ITEM.isActive)
                    return;
                this.#toggle_selection_of_item(DROPDOWN_ITEM);
                this.#fire_events(DROPDOWN_ITEM, 'itemClick', 'itemSelect');
            };
            DROPDOWN_ITEM.deselect = () => {
                if (!DROPDOWN_ITEM.isSelected || !DROPDOWN_ITEM.isActive)
                    return;
                this.#toggle_selection_of_item(DROPDOWN_ITEM);
                this.#fire_events(DROPDOWN_ITEM, 'itemClick', 'itemDeselect');
            };
            DROPDOWN_ITEM.toggleSelect = () => {
                if (DROPDOWN_ITEM.isSelected) {
                }
                else {
                    DROPDOWN_ITEM.select();
                }
            };
        }
        const dropdown_icon = document.createElement('span');
        dropdown_icon.classList.add('material-symbols-rounded');
        dropdown_icon.innerHTML = 'arrow_forward_ios';
        dropdown_item_element.addEventListener('mousemove', (e) => {
            if (DROPDOWN_ITEM.children && DROPDOWN_ITEM.children.length > 0) {
                if (this.#is_at_left_side(dropdown_item_element, e, 0.15) && item.active) {
                    labelContainer.classList.add('scale-up');
                    dropdown_icon.classList.remove('scale-up');
                }
                else {
                    dropdown_icon.classList.add('scale-up');
                    labelContainer.classList.remove('scale-up');
                }
            }
            else {
                labelContainer.classList.add('scale-up');
            }
        });
        dropdown_item_element.addEventListener('mouseleave', (e) => {
            labelContainer.classList.remove('scale-up');
            dropdown_icon.classList.remove('scale-up');
        });
        DROPDOWN_ITEM.setActive(item.active);
        labelContainer.appendChild(label);
        dropdown_item_element.appendChild(labelContainer);
        dropdown_item_wrapper.appendChild(dropdown_item_element);
        if (item.children && item.children.length > 0) {
            DROPDOWN_ITEM.children = [];
            DROPDOWN_ITEM.expand = () => {
                children_wrapper.classList.add('active');
            };
            DROPDOWN_ITEM.collapse = () => {
                dropdown_icon.classList.remove('active');
                children_wrapper.classList.remove('active');
            };
            const children_wrapper = document.createElement('div');
            children_wrapper.classList.add('children');
            this.#level++;
            children_wrapper.appendChild(this.#attach_select_all_to_label(this.#level, DROPDOWN_ITEM));
            item.children.forEach((child) => {
                const child_item_data = this.#create_dropdown_item(child, DROPDOWN_ITEM);
                DROPDOWN_ITEM.children?.push(child_item_data);
                children_wrapper.appendChild(child_item_data.wrapper);
            });
            this.#level--;
            dropdown_item_wrapper.appendChild(children_wrapper);
            dropdown_item_element.appendChild(dropdown_icon);
            dropdown_item_element.addEventListener('click', (e) => {
                e.stopPropagation();
                if (this.#is_at_left_side(dropdown_item_element, e, 0.15) && item.active) {
                    DROPDOWN_ITEM.toggleSelect();
                }
                else {
                    if (dropdown_icon.classList.contains('active')) {
                        DROPDOWN_ITEM.collapse();
                    }
                    else {
                        dropdown_icon.classList.add('active');
                        DROPDOWN_ITEM.expand();
                        DROPDOWN_ITEM.children?.forEach((child) => {
                            child.element.classList.remove('hidden');
                        });
                    }
                }
            });
        }
        else {
            dropdown_item_element.addEventListener('click', (e) => {
                e.stopPropagation();
                DROPDOWN_ITEM.toggleSelect();
            });
        }
        this.dropdown_items.all_items.push(DROPDOWN_ITEM);
        this.dropdown_items.key_items[this.#level] ? this.dropdown_items.key_items[this.#level].push(DROPDOWN_ITEM) :
            this.dropdown_items.key_items[this.#level] = [DROPDOWN_ITEM];
        if (item.selected) {
            DROPDOWN_ITEM.select();
        }
        return DROPDOWN_ITEM;
    }
    #create_group_label(levelItem) {
        const group_label_wrapper = document.createElement('div');
        const group_label = document.createElement('div');
        group_label_wrapper.classList.add('group-label-wrapper');
        group_label.classList.add('group-label');
        group_label.innerHTML = typeof levelItem === 'string' ? levelItem : levelItem.name;
        group_label_wrapper.appendChild(group_label);
        return group_label_wrapper;
    }
    #attach_select_all_to_label(level, parent) {
        const levelItem = this.options.levels[level];
        const group_label_wrapper = this.#create_group_label(this.options.levels[level]);
        (typeof levelItem === 'string' || levelItem.selectAll === true) && this.options.multiSelect && group_label_wrapper.appendChild(this.#create_select_all_item(parent));
        return group_label_wrapper;
    }
    #create_select_all_item(parent) {
        const select_all_item = document.createElement('div');
        select_all_item.classList.add('select-all-item');
        select_all_item.innerHTML = 'Select all';
        parent && (parent.select_all_item = select_all_item);
        let state = 'select';
        select_all_item.addEventListener('click', () => {
            const iterator = parent ? parent.children : this.dropdown_items.key_items[0];
            iterator.forEach((item) => {
                if (!item.isSelected && state === 'select')
                    item.select();
                else if (item.isSelected && state === 'deselect')
                    item.deselect();
            });
            if (state === 'select') {
                state = 'deselect';
                select_all_item.innerHTML = 'Deselect all';
            }
            else {
                state = 'select';
                select_all_item.innerHTML = 'Select all';
            }
        });
        return select_all_item;
    }
    #search(value) {
        let search_value = value.toLowerCase();
        this.dropdown_items.all_items.forEach((item) => {
            this.#item_visibility(item, false);
        });
        this.dropdown_items.all_items.forEach((item) => {
            if (item.name?.toLowerCase().includes(search_value)) {
                this.#item_visibility(item, true);
            }
        });
        if (search_value === '') {
            this.dropdown_items.all_items.forEach((item) => {
                item.collapse ? item.collapse() : null;
            });
        }
        this.#set_dropdown_css(this.dropdown_wrapper, this.element);
    }
    #item_visibility(item, visible) {
        if (visible) {
            item.element.classList.remove('hidden');
        }
        else {
            item.element.classList.add('hidden');
        }
        if (item.parent) {
            this.#item_visibility(item.parent, visible);
            if (visible) {
                item.parent.expand();
            }
            else {
                item.parent.collapse();
            }
        }
    }
    #fire_events(data, ...events) {
        events.forEach((event) => {
            this.element.dispatchEvent(new CustomEvent(event, { detail: data, bubbles: true }));
        });
    }
    #set_dropdown_css(dropdown, element, bias = this.#bias) {
        const element_rect = element.getBoundingClientRect();
        dropdown.style.top = `${element_rect.top + element_rect.height + bias + window.scrollY}px`;
        dropdown.style.left = `${element_rect.left + window.scrollX}px`;
        dropdown.style.width = `${element_rect.width}px`;
        const dropdown_rect = dropdown.getBoundingClientRect();
        if (dropdown_rect.bottom > window.innerHeight) {
            dropdown.style.top = `${element_rect.top - dropdown_rect.height - bias + window.scrollY}px`;
        }
    }
    #is_at_left_side(element, e, bias = 0) {
        const dropdown_item_rect = element.getBoundingClientRect();
        const mouse_position = e.clientX;
        let left_side = dropdown_item_rect.left + dropdown_item_rect.width / 2;
        left_side -= dropdown_item_rect.width * bias;
        return mouse_position < left_side;
    }
    #toggle_selection_of_item(item, updateFormInputs = true) {
        if (this.options.multiSelect) {
            if (!item.checkbox_element)
                return;
            const selected = item.checkbox_element.getAttribute('checked') === 'true';
            if (selected) {
                item._select();
                if (this.options.parentSelect) {
                    let parent = item.parent;
                    while (parent) {
                        !parent.isSelected ? parent.select() : null;
                        parent = parent.parent;
                    }
                }
                if (this.options.parentSelectAll) {
                    item.children?.forEach(child => {
                        !child.isSelected ? child.select() : null;
                    });
                    let parent = item.parent;
                    while (parent) {
                        !parent.isSelected ? parent._select() : null;
                        if (!parent.shouldSelectAll()) {
                            parent.checkbox_element?.setAttribute('int', 'true');
                        }
                        else {
                            parent.checkbox_element?.setAttribute('int', 'false');
                        }
                        parent = parent.parent;
                    }
                }
                if (this.options.disableChildrenOnParentSelect) {
                    let currentChildren = item.children ?? [];
                    while (currentChildren.length > 0) {
                        let furtherChildren = [];
                        currentChildren.forEach(child => {
                            child.deselect();
                            child.setActive(false);
                            if (child.children)
                                furtherChildren.push(...child.children);
                        });
                        currentChildren = furtherChildren;
                    }
                }
            }
            else {
                item._deselect();
                if (this.options.parentSelect) {
                    item.children?.forEach(child => child.isSelected ? child.deselect() : null);
                }
                if (this.options.parentSelectAll) {
                    let currentChildren = item.children ?? [];
                    while (currentChildren.length > 0) {
                        let furtherChildren = [];
                        currentChildren.forEach(child => {
                            child._deselect();
                            if (child.children)
                                furtherChildren.push(...child.children);
                        });
                        currentChildren = furtherChildren;
                    }
                    if (item.parent) {
                        if (item.parent.selected_children_count > 0) {
                            item.parent.checkbox_element?.setAttribute('int', 'true');
                        }
                        else {
                            item.parent.checkbox_element?.setAttribute('int', 'false');
                            item.parent.deselect();
                        }
                    }
                }
                if (this.options.disableChildrenOnParentSelect) {
                    let currentChildren = item.children ?? [];
                    while (currentChildren.length > 0) {
                        let furtherChildren = [];
                        currentChildren.forEach(child => {
                            child.setActive(true);
                            if (child.children)
                                furtherChildren.push(...child.children);
                        });
                        currentChildren = furtherChildren;
                    }
                }
            }
            if (this.selected_items.length > 0) {
                this.input.placeholder = `Selected ${this.selected_items.length} ${this.options.entry}(s)`;
                this.chip_container_wrapper.classList.remove('hidden');
                this.#bias = 10;
            }
            else {
                this.input.placeholder = this.options.searchPlaceholder;
                this.chip_container_wrapper.classList.add('hidden');
                this.#bias = 5;
            }
            this.#set_dropdown_css(this.dropdown_wrapper, this.element);
        }
        else {
            if (!item.isSelected) {
                this.selected_items.forEach(selected_item => selected_item.item.deselect());
                item._select();
                this.input.value = '';
                this.input.placeholder = item.name;
                this.#toggle_dropdown?.call(this, false);
            }
            else {
                item._deselect();
                this.input.value = '';
                this.input.placeholder = this.options.searchPlaceholder;
            }
        }
        if (updateFormInputs)
            this.#set_input_values();
    }
    #set_input_values() {
        if (!this.options.createIndividualInputFields) {
            this.main_invisible_input.setAttribute('value', JSON.stringify(this.getValues()));
        }
        else {
            this.form_input_container.textContent = '';
            const values = this.getValues();
            Object.entries(values).forEach(([key, values]) => {
                if (!this.options.createDuplicateKeyInputFields) {
                    this.form_input_container.appendChild(this.#create_form_input(key, values));
                }
                else {
                    values.forEach((val) => {
                        this.form_input_container.appendChild(this.#create_form_input(key, val));
                    });
                }
            });
        }
    }
    #create_form_input(name, value) {
        const input = document.createElement('input');
        input.setAttribute('type', 'hidden');
        input.setAttribute('name', name);
        input.setAttribute('value', Array.isArray(value) ? JSON.stringify(value) : value);
        return input;
    }
    #create_chip(item) {
        const chip_close = document.createElement('button');
        chip_close.classList.add('chip-close', 'material-symbols-rounded');
        chip_close.innerHTML = 'close';
        const chip = document.createElement('div');
        chip.classList.add('multi-layer-chip');
        chip.innerText = item.name;
        chip_close.addEventListener('click', (e) => {
            if (!item.checkbox_element)
                return;
            e.stopPropagation();
            item.checkbox_element.dispatchEvent(new Event('click'));
        });
        chip.appendChild(chip_close);
        return chip;
    }
}
exports.default = MultiLayerDropdown;
